import { CookieBanner } from "@/components/CookieBanner";
import { Nav } from "@/components/Nav";
import { TechMarquee } from "@/components/TechMarquee";
import { LocaleProvider, useLocale } from "@/i18n/locale";
import { ConsentProvider } from "@/lib/consent-context";
import { ui } from "@/i18n/ui";
import { About } from "@/sections/About";
import { Contact } from "@/sections/Contact";
import { Experience } from "@/sections/Experience";
import { Hero } from "@/sections/Hero";
import { SelectedWork } from "@/sections/SelectedWork";
import { Skills } from "@/sections/Skills";

function Page() {
  const { t } = useLocale();

  return (
    <>
      <a
        href="#main"
        className="sr-only rounded-sm border border-border bg-surface px-4 py-2 text-sm focus:not-sr-only focus:absolute focus:top-3 focus:left-3 focus:z-[60]"
      >
        {t(ui.skipToContent)}
      </a>

      <Nav />

      <main id="main">
        <Hero />
        <TechMarquee />
        <SelectedWork />
        <Experience />
        <Skills />
        <About />
      </main>

      <Contact />
      <CookieBanner />
    </>
  );
}

export default function App() {
  return (
    // ConsentProvider sits inside LocaleProvider: it reads the locale to tag
    // the analytics config, and the banner's copy is translated.
    <LocaleProvider>
      <ConsentProvider>
        <Page />
      </ConsentProvider>
    </LocaleProvider>
  );
}
